/**
 * mfe-reports Routes
 *
 * Defines the reports route that can be:
 * - Accessed directly via /reports
 * - Opened as a modal from workspace
 */

import React from 'react'
import type { RouteObject } from 'react-router-dom'

const ReportsApp = React.lazy(() => import('./App'))

export function getReportsRoutes(): RouteObject[] {
  return [
    {
      path: '/reports',
      element: <ReportsApp />,
    },
  ]
}

export default getReportsRoutes
